import styled from 'styled-components';


export default styled.div`
  padding: 36px 0;
  text-align: center;
  color: #aaaaaa;
  margin-top: 16px;
  font-size: 16px;
  background: #fff;
  border-radius: 6px;
`;

